import { createSelector } from '@reduxjs/toolkit';

import { lessonSectionSelectAll } from '@/Module/Lesson/Store/Selector/index';
import type { IState } from '@/Module/Store/Model';

export const selectedLessonSectionSelector = createSelector(
  [(state: IState) => state.lessonSection.selectedLessonSectionId, (state: IState) => lessonSectionSelectAll(state)],
  (selectedLessonSectionId, selectedLessonSectionList) => {
    return selectedLessonSectionList.find(item => item.id === selectedLessonSectionId);
  },
);
